import { animate, animation, style, transition, trigger } from '@angular/animations';

export const listAnimationElement = 'list-animation-element';

export const easeOutQuart = 'cubic-bezier(0.165, 0.84, 0.44, 1)';
export const easeInOutQuart = 'cubic-bezier(0.77, 0, 0.175, 1)';

export const sectionAnimation = trigger('sectionAnimation', [
    transition(':enter', [
        style({ transform: 'translateY(80px)', opacity: 0, position: 'fixed' }),
        animate('850ms 450ms cubic-bezier(1, 0, 0, 1)', style({
            transform: 'translateY(0)',
            opacity: 1,
            position: 'static'
        })),
    ]),
    transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1, position: 'fixed', left: 0, padding: '0 1rem' }),
        animate('550ms cubic-bezier(1, 0, 0, 1)', style({ transform: 'translateY(80px)', opacity: 0 }))
    ])
]);

export const pageAnimation = trigger('pageAnimation', [
    transition(':enter', [
        style({
            transform: 'translateY(5%)', opacity: 0, display: 'block', position: 'absolute', top: '1rem', left: '1rem', right: '1rem'
        }),
        animate(`850ms 450ms ${easeOutQuart}`, style({
            transform: 'translateY(0)',
            opacity: 1,
            position: 'static'
        })),
    ]),
    transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1, display: 'block' }),
        animate(`550ms ${easeInOutQuart}`, style({ transform: 'translateY(5%)', opacity: 0 }))
    ])
]);




export const listItemEnterAnimation = animation([
    style({ opacity: 0, transform: 'translateY({{ translate }})', position: 'fixed', height: 0 }),
    animate(
        `550ms 450ms ${easeOutQuart}`,
        style({ opacity: 1, transform: 'translateY(0)', position: 'relative', height: '*' })
    )
]);

export const listItemLeaveAnimation = animation([
    animate(
        `450ms ${easeInOutQuart}`,
        style({ transform: 'translateY({{ translate }})', opacity: 1, position: 'fixed', height: '0' })
    )
]);

